import React from 'react';

const SPEAKER_LABELS = {
  ops: 'Bot',
  driver: 'Driver',
  customer: 'Customer',
  lead: 'Lead',
  uncertain: 'Uncertain',
};

export function parseCorrectedTurns(transcript) {
  if (!transcript) return [];
  const match = String(transcript).match(/^## Summary\s*\n(\{.*\})\s*$/m);
  if (match) {
    try {
      const data = JSON.parse(match[1]);
      if (Array.isArray(data.turns)) {
        return data.turns
          .filter((turn) => turn && String(turn.text || '').trim())
          .map((turn) => ({
            speaker: turn.speaker || 'uncertain',
            text: String(turn.text).trim(),
          }));
      }
    } catch {
      /* fall through to the dialogue lines */
    }
  }
  const body = String(transcript).split(/\n## Summary\b/)[0];
  return body.split('\n').map((line) => {
    const lineMatch = line.match(/^(Ops|Driver|Customer|Lead|Uncertain):\s*(.+)$/);
    if (!lineMatch) return null;
    const speaker = {
      Ops: 'ops',
      Driver: 'driver',
      Customer: 'customer',
      Lead: 'lead',
      Uncertain: 'uncertain',
    }[lineMatch[1]];
    return { speaker, text: lineMatch[2].trim() };
  }).filter(Boolean);
}

export default function CorrectedCallTranscript({ transcript }) {
  const turns = parseCorrectedTurns(transcript);
  if (!turns.length) {
    return (
      <div style={{ fontSize: 13, color: '#6b7280' }}>
        Corrected transcript is not ready yet. It is written after the recording is processed.
      </div>
    );
  }
  return (
    <div
      style={{
        maxHeight: 280,
        overflowY: 'auto',
        padding: 12,
        background: '#fafafa',
        border: '1px solid #e5e7eb',
        borderRadius: 8,
      }}
    >
      {turns.map((turn, idx) => {
        const isDriver = turn.speaker === 'driver';
        return (
          <div
            key={`${idx}-${turn.speaker}`}
            style={{
              marginBottom: 8,
              display: 'flex',
              justifyContent: isDriver ? 'flex-end' : 'flex-start',
            }}
          >
            <div
              style={{
                maxWidth: '85%',
                padding: '7px 10px',
                borderRadius: 10,
                background: isDriver ? '#eff6ff' : '#ecfdf5',
                border: '1px solid #e5e7eb',
              }}
            >
              <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 3 }}>
                {SPEAKER_LABELS[turn.speaker] || 'Uncertain'}
              </div>
              <div style={{ fontSize: 13, whiteSpace: 'pre-wrap' }}>{turn.text}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
